export default () => ({
  root: {},
  boxWrapper: { paddingBottom: 24, paddingTop: 38 },
  header: { display: 'flex', alignItems: 'center' },
  cnpj: { marginTop: 7 },
});
